var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{ref:"generalModal",staticClass:"dialog-z-index-general",attrs:{"persistent":_vm.persistant,"max-width":_vm.width,"max-height":_vm.height},model:{value:(_vm.localDialog),callback:function ($$v) {_vm.localDialog=$$v},expression:"localDialog"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }